import "../ProductDetail/index.css";
import { NonCompanyComponent } from "../../components/ProductComponent";
import Delete from "../../components/Option/Delete";
import { Back2 } from "../../components/Option/Back";
import { useState, useEffect } from "react";
import Add from "../../components/Option/Add";
import { getMaterial } from "../../apis/Dropdown";
import { createProduct } from "../../apis/Product";
import AddComponents from "../ProductDetail/Component/AddComponents";
import componenticon from "../../assets/shapes_svg/product/component.svg";
import { Header as ComponentHeader } from "../ProductDetail/Component/Components";
import "../ProductDetail/Component/tablecomponents.css";
import { createService } from "../../apis/Service";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ContainerBody } from "../../App";
const AddService = () => {
  const [name, setName] = useState("");
  const [idBusiness, setIdBusiness] = useState("");

  const apiVariable = [
    "name",
    "category",
    "qty",
    "shipped_from",
    "shipped_by",
    "new_figure",
    "source",
  ];
  const [components, setComponents] = useState([
    {
      [apiVariable[0]]: "",
      [apiVariable[1]]: "",
      [apiVariable[2]]: "",
      [apiVariable[3]]: "",
      [apiVariable[4]]: "",
    },
  ]);

  const [dropdownMaterial, setDropdownMaterial] = useState([]);
  const [dropdownBy, setDropdownBy] = useState([
    { id: 1, name: "Road", value: "Road" },
    { id: 2, name: "Rail", value: "Rail" },
    { id: 3, name: "Air", value: "Air" },
    { id: 4, name: "Sea", value: "Sea" },
  ]);
  const [errorMessage, setErrorMessage] = useState();
  const [status, setStatus] = useState(false);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleMove = useCallback(
    () => navigate("/service/" + idBusiness, { replace: true }),
    [navigate, idBusiness]
  );

  useEffect(() => {
    if (status == true) handleMove();
  }, [status]);
  const handleSave = () => {
    createService({
      name: name,
      setErrorMessage: setErrorMessage,
      setStatus: setStatus,
      setIdBusiness: setIdBusiness,
    });
  };
  // useEffect(()=> {
  //     getMaterial({setBusinessSizeList:setDropdownMaterial})
  //     // // console.log(dropdownMaterial)
  // },[])
  return (
    <ContainerBody className="product__body">
      <div
        className="productdetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Product Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/product"}
        />
      </div>
      <div className="productdetail">
        <div className="productdetail__info" style={{ flexDirection: "row" }}>
          <NonCompanyComponent name={name} />
          <div className="productdetail__info__info">
            <div className="productdetail__info__title">
              <h4 style={{ fontStyle: "italic" }}>{t("PRODUCT_INFO_1")}</h4>
            </div>
            <div
              style={{ flexDirection: "column" }}
              className="productdetail__info__bubble mt-4"
            >
              {/* <h4 style={{fontStyle:"italic",fontSize:"15px",fontWeight:"300",marginBottom:"10px"}}>If you know how your products or product waste materials are disposed of once users have finished with them, please indicate here.</h4> */}
              <div className="modaladdlocation__question flex-column">
                <div className="d-flex">
                  <h3>{t("NAME")}*:</h3>
                  <input
                    className="custom__input"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                {errorMessage ? (
                  <h4 className="text-danger">{errorMessage.name}</h4>
                ) : null}
              </div>
              {/* <div className="modaladdlocation__question">
                                <h3>Recycled*:</h3>
                                <input className="custom__input" type="number" value={recycled} onChange={(e) => setRecycled(e.target.value)}/>
                            </div>
                            <div className="modaladdlocation__question">
                                <h3>Landfill*:</h3>
                                <input className="custom__input" type="number" value={landfill} onChange={(e) => setLandfill(e.target.value)}/>
                            </div>
                            <div className="modaladdlocation__question">
                                <h3>Burnt*:</h3>
                                <input className="custom__input" type="number" value={burnt} onChange={(e) => setBurnt(e.target.value)}/>
                            </div> */}
            </div>
          </div>
        </div>
        {/* <div className="productdetail__info">
                    <div className="companydetail__title__container">
                        <img src={componenticon} alt="" />
                        <div className="companydetail__info__title companydetail__title__style2 ">
                            <h5>Inputs</h5>
                            <h6><i>If you know how your products or product waste materials are disposed of once users have finished with them, please indicate here.</i></h6>
                            </div>
                    </div>
                    <div className="productdetail__info__bubble" style={{backgroundImage:"none"}}>
                        <ComponentHeader/>
                        <AddComponents components={components}
                        setComponents={setComponents}
                        dropdownMaterial={dropdownMaterial}
                        setDropdownMaterial={setDropdownMaterial}
                        errorMessageInherit={errorMessage}
                        />
                    </div>

                </div> */}
      </div>
      <div className="companydetail__wrapper">
        <div className="companydetail__option">
          <Add header={"Save Service"} style={"product"} click={handleSave} />
          <Delete header={"Delete Service"} style={"product"} />
        </div>
      </div>
    </ContainerBody>
  );
};

export default AddService;
